// extracted by mini-css-extract-plugin
export var formContainer = "_l2-0";
export var message = "_l2-1";